export function getSeenVersions(storageKey) {
    try {
        const parsed = JSON.parse(localStorage.getItem(storageKey) || '[]');
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
}

export function isVersionAlreadySeen(seenVersions, frontendVersion, backendVersion) {
    if (!Array.isArray(seenVersions)) return false;
    return seenVersions.some(entry =>
        entry?.frontendVersion === frontendVersion &&
        entry?.backendVersion === backendVersion
    );
}

export function saveVersionAsSeen(storageKey, frontendVersion, backendVersion) {
    const seenVersions = getSeenVersions(storageKey);
    const alreadySeen = isVersionAlreadySeen(seenVersions, frontendVersion, backendVersion); 

    if (alreadySeen) return;
    
    const modalSeenAt = new Date().toISOString();
    const newEntry = { frontendVersion, backendVersion, modalSeenAt };

    localStorage.setItem(storageKey, JSON.stringify([...seenVersions, newEntry]));
};